/* eslint-disable jsx-a11y/aria-role */
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './CustomSwitchStyle.css';
import { Box } from '@mui/material';
import { CustomSwitchStyles } from './CustomSwitchStyle';
import LeadGenerationContext from '../../../context/LeadGenerationContext';

function CustomSwitch(props) {
  const {
    handleClickCheckbox,
    id,
    defaultData,
    disable,
    ariaLabelName,
    dataTestId,
    toggleCheckboxOnEnter,
    isBundle,
  } = props;
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { theme, productName } = leadGenerationContext;
  const classes = CustomSwitchStyles(theme, defaultData);
  return (
    <Box component="div" sx={[classes.checkSwitchFocus, classes.switchMobMargin]}>
      <Box
        component="input"
        type="checkbox"
        role="toggle switch"
        name={id}
        // className={`${InputClassName || ''} disable && disableCursor checkbox`}
        sx={classes.checkbox}
        data-testid={dataTestId}
        checked={defaultData}
        aria-checked={defaultData}
        id={`${id}-id`}
        onClick={(e) => handleClickCheckbox(e)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            toggleCheckboxOnEnter(id);
          }
        }}
        aria-label={ariaLabelName}
        disabled={disable || false}
      />
      <Box
        component="label"
        sx={disable ? [classes.label, classes.disableCursor] : classes.label}
        htmlFor={`${id}-id`}
      >
        {!isBundle ? (
          <>
            <Box component="span" sx={classes.on}>
              {t('On', {
                defaultValue: 'On',
              })}
            </Box>
            <Box component="span" sx={classes.off}>
              {t('Off', {
                defaultValue: 'Off',
              })}
            </Box>
          </>
        ) : (
          ''
        )}
        <Box component="div" sx={classes.ball} />
      </Box>
    </Box>
  );
}
export default CustomSwitch;
CustomSwitch.propTypes = {
  handleClickCheckbox: PropTypes.func,
  toggleCheckboxOnEnter: PropTypes.func,
  id: PropTypes.string,
  ariaLabelName: PropTypes.string,
  defaultData: PropTypes.string,
  disable: PropTypes.string,
  dataTestId: PropTypes.string,
  isBundle: PropTypes.bool,
};
